export default {
  SHOW_WEB3_CONFIRM_MODAL: 'showWeb3Wallet',
  SHOW_TX_CONFIRM_MODAL: 'showTxConfirmModal',
  SHOW_MSG_CONFIRM_MODAL: 'showMessageConfirmModal',
  SHOW_TX_SIGN_MODAL: 'showTxSignModal',
  CONFIRMED_TX: 'confirmedTx',
  SHOW_BATCH_TX_MODAL: 'showTxCollectionConfirmModal',
  SHOW_SWAP_TX_MODAL: 'showSwapTxConfirmModal',
  SHOW_CROSS_CHAIN_MODAL: 'showCrossChainModal'
};
